export default __webpack_public_path__ + "static/media/appstore.c8a23377.png";